/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type KillswitchLiftRequest = {
  expectedVersion: number;
  id: string;
  operationId: string;
};

/** @internal */
export type KillswitchLiftRequest$Outbound = {
  expected_version: number;
  id: string;
  operation_id: string;
};

/** @internal */
export const KillswitchLiftRequest$outboundSchema: z.ZodMiniType<
  KillswitchLiftRequest$Outbound,
  KillswitchLiftRequest
> = z.pipe(
  z.object({
    expectedVersion: z.int(),
    id: z.string(),
    operationId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      expectedVersion: "expected_version",
      operationId: "operation_id",
    });
  }),
);

export function killswitchLiftRequestToJSON(
  killswitchLiftRequest: KillswitchLiftRequest,
): string {
  return JSON.stringify(
    KillswitchLiftRequest$outboundSchema.parse(killswitchLiftRequest),
  );
}
